import { createFileRoute, redirect } from "@tanstack/react-router";
import { getRecordWorkspacePath } from "@/features/tickets/lib/get-record-workspace-path.util";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/tickets/(ticket)/$ticketId/workspace/records/$recordId/workspace/",
)({
	beforeLoad: ({ params }) => {
		throw redirect({
			href: getRecordWorkspacePath({
				orgId: params.orgId,
				ticketId: params.ticketId,
				recordId: params.recordId,
				tab: "form",
			}),
		});
	},
});
